export enum EbookTestBookEnum {
  SPECIFY_AMOUNT_CHAPTER = 'SPECIFY_AMOUNT_CHAPTER',
  SELECT_CHAPTER = 'SELECT_CHAPTER',
}
